import axios from 'axios'

export const getClients = () => {
    return axios.get(`clients`).then(res => res.data.data)
};
